<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { useConfirmModalStore } from '@/stores/confirmModal'

const confirmModal = useConfirmModalStore()
const okBtnRef = ref<HTMLButtonElement | null>(null)

// モーダルが開いたらOKボタンにフォーカスし、Enter/Escapeで操作できるようにする
watch(
  () => confirmModal.message,
  (msg) => {
    if (msg) {
      nextTick(() => okBtnRef.value?.focus())
      window.addEventListener('keydown', onKeydown)
    } else {
      window.removeEventListener('keydown', onKeydown)
    }
  },
)

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') confirmModal.resolve(false)
  else if (e.key === 'Enter') confirmModal.resolve(true)
}
</script>

<template>
  <div v-if="confirmModal.message" class="confirm-modal-overlay" @click="confirmModal.resolve(false)">
    <div class="confirm-modal" @click.stop>
      <div class="confirm-modal-message">{{ confirmModal.message }}</div>
      <div class="confirm-modal-actions">
        <button class="btn btn-ghost" @click="confirmModal.resolve(false)">キャンセル</button>
        <button ref="okBtnRef" class="btn btn-primary" @click="confirmModal.resolve(true)">OK</button>
      </div>
    </div>
  </div>
</template>
